"use client";
import { FC } from "react";
import RentalCarSearchForm from "./(car-search-form)/RentalCarSearchForm";
export type SearchTab = "Cars";

export interface HeroSearchFormProps {
  className?: string;
  currentTab?: SearchTab;
  currentPage?: "Cars";
}

export const HeroSearchForm: FC<HeroSearchFormProps> = ({ className = "" }) => {
  return (
    <div
      className={`nc-HeroSearchForm w-full max-w-6xl bg-[#FFFFFF29] rounded-lg p-4 ${className} `}
    >
      <RentalCarSearchForm />
    </div>
  );
};
